<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
   sodipodi:docname="tongue_S_triangle_4.svg"
   id="svg1118"
   version="1.1"
   viewBox="0 0 360 400"
   :height="height"
   :width="width">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     inkscape:window-maximized="1"
     inkscape:window-y="23"
     inkscape:window-x="0"
     inkscape:window-height="755"
     inkscape:window-width="1280"
     scale-x="1"
     units="px"
     showgrid="false"
     inkscape:document-rotation="0"
     inkscape:current-layer="layer1"
     inkscape:document-units="px"
     inkscape:cy="187.25371"
     inkscape:cx="196.45427"
     inkscape:zoom="0.98994949"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     borderopacity="1.0"
     bordercolor="#666666"
     pagecolor="#ffffff"
     id="base" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
    <path
       id="outside"
       style="fill:#ff000000;stroke:#ffffff;stroke-width:0.917065;stroke-opacity:1"
       d="M 0 0 L 0 400 L 55.558594 400 L 55.558594 399.54102 L 332.04102 399.54102 L 332.04102 399.5 L 360.62305 399.5 L 360.62305 0.5 L 332.04102 0.5 L 332.04102 0.45898438 L 55.558594 0.45898438 L 55.558594 0 L 0 0 z M 225.70703 22.044922 C 237.19017 21.838054 248.52881 30.202356 262.50195 62.455078 C 300.25356 149.59313 265.96006 376.93654 179.67578 377.95508 C 92.528966 373.88092 60.205408 149.16575 97.658203 61.900391 C 126.66979 -5.6968666 149.22824 33.378681 182.05273 33.472656 C 199.49074 33.522576 212.6928 22.279373 225.70703 22.044922 z " />
    <path
       id="mouth"
       style="fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       d="M 180 8.7871094 C 117.76101 8.7872428 67.307033 23.06088 67.308594 40.667969 C 67.309694 46.932323 86.086495 57.788233 98.320312 63.009766 C 127.09882 -4.044429 149.47632 34.717328 182.03711 34.810547 C 214.5979 34.903767 232.268 -4.6944417 261.83789 63.558594 C 262.16871 64.322191 262.4811 65.121196 262.80078 65.90625 C 275.08138 60.337811 292.69073 46.769471 292.69141 40.667969 C 292.69297 23.06088 242.23899 8.7872422 180 8.7871094 z " />
  <g id="cover_layer">
     <path
       sodipodi:nodetypes="szsss"
       inkscape:connector-curvature="0"
       id="cover"
       d="M 107.44584,58.441158 C 74.482122,135.24692 129.46481,336.52381 179.63372,336.61433 229.80262,336.70485 285.75781,135.62326 252.53109,58.92955 226.29466,-1.6292179 210.61628,33.503798 181.72612,33.421087 152.83595,33.338377 132.9801,-1.0539156 107.44584,58.441158 Z"
       style="display:inline;fill:none;stroke:#ff000000;stroke-width:1.75007px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
  </g>
  <g
     id="body_layer"
     inkscape:groupmode="layer"
     inkscape:label="Layer 1">
    <path
       sodipodi:nodetypes="szsss"
       inkscape:connector-curvature="0"
       id="body"
       d="M 98.319393,63.008993 C 61.167486,149.57328 123.13598,376.42332 179.67907,376.52534 236.22216,376.62736 299.28672,149.99743 261.83839,63.559437 232.2685,-4.6935985 214.59811,34.903228 182.03732,34.810008 149.47653,34.716789 127.0979,-4.0452015 98.319393,63.008993 Z"
       style="display:inline;fill:#f59a9a;stroke:#ff000000;stroke-width:1.97243px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
    <path
       id="lg"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 180.45312 280.76172 C 160.49634 280.70463 140.6479 287.44035 119.97852 301.83789 C 125.96185 317.0629 132.50035 330.75532 139.37109 342.14062 C 168.80041 331.69193 195.73183 332.19526 220.67969 341.40234 C 227.75553 329.63768 234.48829 315.47912 240.625 299.74414 C 219.865 287.45274 200.10294 280.81865 180.45312 280.76172 z " />
    <path
       id="he"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 182.81055 334.13281 C 168.87798 333.95653 154.34506 336.41169 139.15039 341.76953 C 151.09575 361.67132 164.04447 374.59938 176.8125 376.32227 C 177.55582 376.39945 178.30308 376.46162 179.05469 376.50586 C 179.26301 376.51236 179.47151 376.52502 179.67969 376.52539 C 193.48744 376.5503 207.68016 363.03067 220.70703 341.35742 C 208.56472 336.80222 195.95357 334.29911 182.81055 334.13281 z " />
    <path
       d="M 225.34067,23.473937 C 212.43099,23.706505 199.33477,34.859696 182.03685,34.810173 149.47607,34.716955 127.09783,-4.0450606 98.319325,63.009134 95.247142,70.16736 92.65807,78.273895 90.524112,87.095952 160.6095,102.12187 216.76276,97.021701 269.50474,86.990462 267.40451,78.406933 264.85689,70.526914 261.83856,63.560026 247.97767,31.566415 236.73155,23.268731 225.34067,23.473937 Z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="k-bl-li"
       inkscape:connector-curvature="0" />
    <path
       id="lv-gb-l"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 269.05273 87.375 L 236.8125 92.529297 C 248.46377 168.76994 245.13729 231.54901 235.93945 296.84766 L 240.58789 299.83789 C 265.67094 235.57288 280.83024 145.3032 269.05273 87.375 z " />
    <path
       id="lv-gb-r"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.920428;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 91.041016 87.429688 C 79.406351 146.03144 94.656892 237.22712 119.8457 301.50391 L 123.63477 298.66992 C 115.05745 229.16508 112.42136 165.14645 122.40234 92.902344 L 91.041016 87.429688 z " />
    <path
       id="st-sp"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.708228;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 123.63782,298.67044 c -8.57732,-69.50475 -11.2137,-133.5262 -1.23272,-205.770316 42.25648,5.560681 79.46895,4.170294 114.41082,-0.346332 11.64612,76.227938 8.32104,139.004258 -0.87563,204.294888 -42.94166,-23.10393 -73.0933,-20.60052 -112.30247,1.82145 z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="cccccc" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>